import { TableRow } from '../../types';

export const getColumnSortingValue = (columnData: TableRow, columnKey: keyof TableRow): string | number | Date => {
  const colValue = columnData[columnKey];
  return typeof colValue === 'object' ? colValue.sortingValue : colValue;
};
